import { render, staticRenderFns } from "./ShowBanner.vue?vue&type=template&id=24b00631"
import script from "./ShowBanner.vue?vue&type=script&lang=js"
export * from "./ShowBanner.vue?vue&type=script&lang=js"
import style0 from "./ShowBanner.vue?vue&type=style&index=0&id=24b00631&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports